import {
  CREATE_TESTS_ORDER,
} from './constants'

export function createOrder (payload) {
  return {
    type: CREATE_TESTS_ORDER,
    payload,
  }
}
